"use strict";
var Observable_1 = require("../../Observable");
var switchMap_1 = require("../../operator/switchMap");
Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
//# sourceMappingURL=switchMap.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/add/operator/switchMap.js
 ** module id = 84
 ** module chunks = 1
 **/